﻿import {PaymentMethodEditGateway} from './paymentMethodEdit.gateway';
import {PaymentMethodEditViewModel} from './paymentMethodEdit.viewmodel';
import {IPaymentMethodEditParams} from './paymentMethodEditParams';
import * as LogService from "../../core/services/logservice/log.service";
import {ScreenLockService} from "../../core/services/screenLockService/screenLock.service";
import {IErrorRedirectService} from '../../core/services/errorRedirectService/errorRedirect.service';
import {ErrorInformation} from '../../core/services/errorRedirectService/errorInformation.model';
import * as _ from 'lodash';
import {PaymentAccountTypeService} from "./paymentAccountType.service";

export class PaymentMethodEditController {

    private paymentMethodEditViewModel: PaymentMethodEditViewModel;
    public paymentMethodEditForm: ng.IFormController;

    static $inject = [
        '$stateParams', 'errorRedirectService', 'ValidationService', '$state', '$uibModal', '$scope', 'logService',
        'screenLockService', 'paymentMethodEdit.gateway', '$q', 'paymentAccountType.service'
    ];

    constructor(
        private $stateParams: IPaymentMethodEditParams,
        private errorRedirectService: IErrorRedirectService,
        private validationService: any,
        private $state: ng.ui.IStateService,
        private $modal: any,
        private $Scope: any,
        private logger: LogService.ILogService,
        private screenLockService: ScreenLockService,
        private paymentMethodEditGateway: PaymentMethodEditGateway,
        private $q: ng.IQService,
        private paymentAccountTypeService: PaymentAccountTypeService){

        this.activate();

    }

    private activate() {

        // this is required in order to set up the validation service to work with the form using "controller as" syntax
        this.validationService = new this.validationService({ controllerAs: this });

        this.screenLockService.broadcast(1);

        this.paymentMethodEditGateway.loadPaymentMethodEditViewModel(this.$stateParams.policyholderid)
            .then((paymentMethodEditViewModel: PaymentMethodEditViewModel) => {
                this.paymentMethodEditViewModel = paymentMethodEditViewModel;
                this.screenLockService.broadcast(0);
            });
    }
    
    public goToAdminPayment(): void {
        this.$state.go('shellFrame.administrationFrame.adminPayment',{policyholderid: this.$stateParams.policyholderid});
    }

    public setPaymentMethodDirty(paymentMethodId:string): void {

        let dirtyPaymentMethod = _.find(this.paymentMethodEditViewModel.getPaymentMethods, {'tokenId': paymentMethodId});
        dirtyPaymentMethod.isDirty = true;
    }

    public save(): ng.IPromise<any> {

        let promises = [];
        promises.push(this.paymentMethodEditGateway.updateAutoPayToken(this.paymentMethodEditViewModel));
        promises.push(this.paymentMethodEditGateway.updatePaymentMethods(this.paymentMethodEditViewModel));

        return this.$q.all(promises).then(()=>{
            this.$state.go('shellFrame.administrationFrame.adminPayment', { policyholderid: this.$stateParams.policyholderid });
        })

    }


}
